import type { InternalAxiosRequestConfig } from "axios";
import { useSafeConfigSlice } from "../../../packages/config/safe-config";
import useReCaptchaService from "../../../services/re-captcha";
import { isEOSRequestConfig } from "../index.types";

const useReCaptchaInterceptor = () => {
	const { REACT_APP_RECAPTCHA_CONSUMER, REACT_APP_REFERRER_URL } =
		useSafeConfigSlice([
			"REACT_APP_RECAPTCHA_CONSUMER",
			"REACT_APP_REFERRER_URL",
		]);
	const service = useReCaptchaService();

	return async (config: InternalAxiosRequestConfig) => {
		try {
			if (!isEOSRequestConfig(config)) return config;
			if (!config.includeReCaptcha) return config;
			const reCaptchaToken = await service.findReCaptchaToken();
			if (config.method === "get") {
				config.headers["x-auth-token"] = reCaptchaToken;
				config.headers["x-consumer"] = REACT_APP_RECAPTCHA_CONSUMER;
				config.headers["x-referrer"] = REACT_APP_REFERRER_URL;
			} else {
				const data = config.data;
				data.tokenAttributes = {
					xauthToken: reCaptchaToken,
					xconsumer: REACT_APP_RECAPTCHA_CONSUMER,
					xreferrer: REACT_APP_REFERRER_URL,
				};
			}
			return config;
		} catch (err) {
			return Promise.reject(err);
		}
	};
};

export default useReCaptchaInterceptor;
